import React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { RadioProps } from "../../types/components/Form";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  radioLabel: {
    fontSize: "12px", // Adjust the font size as needed
  },
});

interface Props {
  value: string;
  defaultValue?: boolean;
  label?: string;
  radios: RadioProps[];
  onChange: (e: any) => void;
  isRow?: boolean;
  disabled?: boolean;
}

const AppRadio: React.FC<Props> = ({
  value,
  label,
  radios,
  onChange,
  isRow = true,
  disabled,
}) => {
  const classes = useStyles();
  return (
    <FormControl>
      <FormLabel>{label}</FormLabel>
      <RadioGroup
        row={isRow}
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={value}
        onChange={onChange}
      >
        {radios.map((radio: RadioProps) => {
          return (
            <FormControlLabel
              classes={{ label: classes.radioLabel }}
              value={radio.value}
              control={<Radio />}
              label={radio.label}
              disabled={disabled}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

export default AppRadio;
